// Material Components
import { Box, ClickAwayListener, Collapse, Link, Tooltip } from "@mui/material";

// Components
import NavButton from "components/HeaderNavigation/NavButton";
import ProjectionActions from "components/Projection/ProjectionActions";
import { CompanySummaryHeader, CompanySummaryBody, CompanySummaryFooter } from "components/CompanySummary";

// Hooks
import useProjectionHeader from "./useProjectionHeader";

// Utils
import icons from "enums/icons";
import { flattenSectorProductsDomain } from "services/company/company.functions";

// Styles
import projectionHeaderStyles from "./ProjectionHeader.styles";

// Types
import CustomIcon from "components/CustomIcon";

const ProjectionHeader = ({
    companyData,
}: {
    companyData: ReturnType<typeof flattenSectorProductsDomain> | undefined;
}): JSX.Element => {
    const classes = projectionHeaderStyles();

    const {
        searchName,
        companyInfoVisible,
        isPathToImprovementVisible,
        handleBackToInsights,
        handleGoToDashboard,
        handleClickToImprovement,
        handleToggleCompanyInfo,
        handleClickAway,
    } = useProjectionHeader();

    const companyName = companyData?.name ?? "";

    return (
        <ClickAwayListener onClickAway={handleClickAway}>
            <Box className={classes.projectionHeader}>
                <Box className={classes.projectionHeaderCompanyContainer}>
                    <Box className={classes.companyContainer}>
                        <CompanySummaryHeader
                            showAvatar
                            truncateTitle
                            title={companyName}
                            link={
                                <Tooltip title={searchName} arrow placement="bottom-start">
                                    <Link
                                        onClick={handleToggleCompanyInfo}
                                        className={classes.summaryHeaderCompanyLink}
                                    >
                                        {companyName}
                                        <CustomIcon
                                            icon={
                                                companyInfoVisible ? icons.circledChevronUp : icons.circledChevronDown
                                            }
                                        />
                                    </Link>
                                </Tooltip>
                            }
                        />
                    </Box>

                    <Box className={classes.actionsContainer}>
                        <ProjectionActions />
                    </Box>

                    <Box className={classes.pathBtnContainer}>
                        <NavButton
                            isBackButton
                            onClick={handleBackToInsights}
                            translationId={
                                isPathToImprovementVisible ? "projection.insights.insights" : "button.backToDashboard"
                            }
                        />
                        {isPathToImprovementVisible ? (
                            <NavButton
                                onClick={handleGoToDashboard}
                                translationId="paceLabsDashbard.insights.back.to.dashboard"
                            />
                        ) : (
                            <NavButton onClick={handleClickToImprovement} translationId="button.pathImprovement" />
                        )}
                    </Box>
                </Box>
                <Collapse in={companyInfoVisible} className={classes.projectionHeaderHiddenPanel}>
                    <CompanySummaryBody companyData={companyData} projection />
                    <CompanySummaryFooter companyData={companyData} />
                </Collapse>
            </Box>
        </ClickAwayListener>
    );
};

export default ProjectionHeader;
